import styled from 'styled-components';
import { ThemeColours } from '../../../styles/ThemeColours';
import { FONT_STACK, FontSize, FontWeight } from '../../../styles/constants';
import { LoadingStrip } from '../../LoadingStrip/LoadingStrip';

interface Props {
  children?: React.ReactNode;
  className?: string;
}

export const Paragraph = ({ className, children, ...restProps }: Props) => {
  if (children) {
    return (
      <View className={className} {...restProps}>
        {children}
      </View>
    );
  }

  return (
    <div>
      <StyledLoading />
      <StyledLoading />
      <StyledLoading />
    </div>
  );
};

const View = styled.p`
  color: ${ThemeColours.mono900};
  display: block;
  ${FONT_STACK}
  font-size: ${FontSize.REGULAR};
  font-weight: ${FontWeight.REGULAR};
  line-height: 1.5em;
  margin: 0 0 14px;
`;

export const StyledLoading = styled(LoadingStrip)`
  height: 16px;
  margin-bottom: 8px;

  &:nth-child(1) {
    width: 96%;
  }

  &:nth-child(2) {
    width: 99%;
  }

  &:nth-child(3) {
    width: 60%;
  }
`;
